
(() => {
  const ready = (fn) => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn();

  ready(() => {
    document.querySelectorAll('[data-fp-popup]').forEach((popup) => {
      const days = Number(popup.dataset.days || 7);
      const delay = Number(popup.dataset.delay || 5) * 1000;
      const key = `fpPopup:${location.pathname}:${popup.closest('.shopify-section')?.id || 'default'}`;
      const hiddenUntil = Number(localStorage.getItem(key) || 0);
      if (Date.now() < hiddenUntil) return;
      window.setTimeout(() => popup.classList.add('is-open'), delay);
      popup.querySelectorAll('[data-fp-popup-close]').forEach((button) => {
        button.addEventListener('click', () => {
          popup.classList.remove('is-open');
          localStorage.setItem(key, String(Date.now() + days * 86400000));
        });
      });
    });

    document.querySelectorAll('[data-fp-age]').forEach((modal) => {
      const days = Number(modal.dataset.days || 30);
      const key = 'fpAgeConfirmed';
      if (Number(localStorage.getItem(key) || 0) > Date.now()) {
        modal.remove();
        return;
      }
      modal.querySelector('[data-fp-age-confirm]')?.addEventListener('click', () => {
        localStorage.setItem(key, String(Date.now() + days * 86400000));
        modal.remove();
      });
    });

    document.querySelectorAll('[data-fp-back-top]').forEach((button) => {
      const threshold = 600;
      const update = () => button.classList.toggle('is-visible', window.scrollY > threshold);
      update();
      window.addEventListener('scroll', update, { passive: true });
      button.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    });
  });
})();
